import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Typography
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import axios from 'axios';
import ResponsiveAppBar from "../ResponsiveAppBar";
import ResponsiveFooter from "../ResponsiveFooter";
import * as constants from "../constants.js";

const AdminUserManagement = () => {
  const [users, setUsers] = useState([]);
  const [isCreateOpen, setCreateOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newName, setNewName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newFreeArea, setNewFreeArea] = useState('');
  const [editFreeArea, setEditFreeArea] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.create({
        withCredentials: true,
      }).get("//" + constants.BASE_URL + "/admin/get_users");
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleCreateUser = async () => {
    setError('');
    try {
      await axios.create({
        withCredentials: true,
      }).post("//" + constants.BASE_URL + "/admin/create_user", {
        name: newName,
        email: newEmail,
        password: newPassword,
        free_area: parseFloat(newFreeArea) || 0
      });
      setCreateOpen(false);
      setNewName('');
      setNewEmail('');
      setNewPassword('');
      setNewFreeArea('');
      fetchUsers();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError("Etwas ist schiefgegangen");
      }
    }
  };

  const handleEditFreeArea = (user) => {
    setSelectedUser(user);
    setEditFreeArea(user.free_area.toString());
    setEditOpen(true);
  };

  const handleSaveFreeArea = async () => {
    try {
      await axios.create({
        withCredentials: true,
      }).post("//" + constants.BASE_URL + "/admin/update_user_free_area", {
        id: selectedUser.id,
        free_area: parseFloat(editFreeArea) || 0
      });
      setEditOpen(false);
      setSelectedUser(null);
      fetchUsers();
    } catch (error) {
      console.error("Error updating free area:", error);
    }
  };

  return (
    <div className="home">
      <ResponsiveAppBar />
      <div className="body-content">
        <br />
        <Typography variant="h4" gutterBottom>Benutzerverwaltung</Typography>
        <Button variant="contained" color="primary" onClick={() => { setCreateOpen(true); setError(''); }}>
          Neuen Benutzer anlegen
        </Button>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>E-Mail</TableCell>
                <TableCell>Free Area (km²)</TableCell>
                <TableCell>Admin</TableCell>
                <TableCell>Aktionen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.free_area}</TableCell>
                  <TableCell>{user.admin ? "Ja" : "Nein"}</TableCell>
                  <TableCell>
                    <IconButton color="primary" onClick={() => handleEditFreeArea(user)}>
                      <Edit />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={isCreateOpen} onClose={() => setCreateOpen(false)}>
          <DialogTitle>Neuen Benutzer anlegen</DialogTitle>
          <DialogContent>
            {error && <Typography color="error" style={{ marginBottom: '10px' }}>{error}</Typography>}
            <TextField
              margin="dense"
              label="Name"
              fullWidth
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
            <TextField
              margin="dense"
              label="E-Mail"
              fullWidth
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Passwort"
              fullWidth
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Free Area (km²)"
              fullWidth
              type="number"
              value={newFreeArea}
              onChange={(e) => setNewFreeArea(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCreateOpen(false)} color="secondary">Abbrechen</Button>
            <Button onClick={handleCreateUser} color="primary">Anlegen</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={isEditOpen} onClose={() => setEditOpen(false)}>
          <DialogTitle>Free Area bearbeiten</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Free Area (km²)"
              fullWidth
              type="number"
              value={editFreeArea}
              onChange={(e) => setEditFreeArea(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditOpen(false)} color="secondary">Abbrechen</Button>
            <Button onClick={handleSaveFreeArea} color="primary">Speichern</Button>
          </DialogActions>
        </Dialog>
      </div>
      <ResponsiveFooter />
    </div>
  );
};

export default AdminUserManagement;
